//#region src/utils/is.ts
function isTypeof(value, type) {
	return typeof value === type;
}
function isToString(value, type) {
	return Object.prototype.toString.call(value) === `[object ${type}]`;
}
function isInstanceOf(value, reference) {
	try {
		return value instanceof reference;
	} catch (_err) {
		return false;
	}
}
const isUndefined = ((value) => isTypeof(value, "undefined"));
const isNull = ((value) => isTypeof(value, "null"));
const isString = ((value) => isTypeof(value, "string"));
const isNumber = ((value) => isTypeof(value, "number") && !isNaN(value) || isTypeof(value, "bigint"));
const isInt = ((value) => isNumber(value) && Number.isInteger(value));
const isBoolean = ((value) => isTypeof(value, "boolean"));
const isSymbol = ((value) => isTypeof(value, "symbol"));
const isObject = ((value) => !isNull(value) && isTypeof(value, "object"));
const isFunction = ((value) => isTypeof(value, "function"));
const isArray = ((value) => isToString(value, "Array"));
const isRegExp = ((value) => isToString(value, "RegExp"));
const isThenable = ((value) => isFunction(value === null || value === void 0 ? void 0 : value.then));
const isPrimitive = ((value) => !isObject(value) && !isFunction(value));
const isEventDefined = typeof Event !== "undefined";
const isEvent = ((value) => isEventDefined && isInstanceOf(value, Event));
const isErrorDefined = typeof Error !== "undefined";
const isError = ((value) => isErrorDefined && isInstanceOf(value, Error));
const isErrorEvent = ((value) => isToString(value, "ErrorEvent"));
const isDomError = ((value) => isToString(value, "DOMError"));
const isDomException = ((value) => isToString(value, "DOMException"));
const isElementDefined = typeof Element !== "undefined";
const isElement = ((value) => isElementDefined && isInstanceOf(value, Element));
const isMapDefined = typeof Map !== "undefined";
const isMap = ((value) => isMapDefined && isInstanceOf(value, Map));
const isSyntheticEvent = ((value) => isObject(value) && "nativeEvent" in value && "preventDefault" in value && "stopPropagation" in value);
function isEmpty(value) {
	if (value == null) return true;
	if (isArray(value) || isString(value)) return value.length === 0;
	if (isObject(value)) return Object.keys(value).length === 0;
	return false;
}
//#endregion
export { isArray, isBoolean, isDomError, isDomException, isElement, isElementDefined, isEmpty, isError, isErrorDefined, isErrorEvent, isEvent, isEventDefined, isFunction, isInstanceOf, isInt, isMap, isMapDefined, isNull, isNumber, isObject, isPrimitive, isRegExp, isString, isSymbol, isSyntheticEvent, isThenable, isToString, isTypeof, isUndefined };

//# sourceMappingURL=is.js.map